import React from 'react';
import './Stlye.css';
import { NavLink } from 'react-router-dom';
import MetaTags from './MetaTags';

function TermsConditions() {
  return (
    <>
      <MetaTags
        title="Terms and Conditions | Smart Resources QLD"
        description="Read the Terms and Conditions governing your access and use of the Smart Resources QLD website and business consulting services."
        identifyUrl="https://smartresourcesqld.com.au/terms-conditions"
        DCTitle="Terms and Conditions | Smart Resources QLD"
        DCDescription="Read the Terms and Conditions governing your access and use of the Smart Resources QLD website and business consulting services."
        DCSubject="Terms and Conditions | Smart Resources QLD"
        Canonical="https://smartresourcesqld.com.au/terms-conditions"
        ogImage="https://smartresourcesqld.com.au/static/media/smart-banner-2.09079fa08d21da7d6cbb.webp"
        ogTitle="Terms and Conditions | Smart Resources QLD"
        ogDescription="Read the Terms and Conditions governing your access and use of the Smart Resources QLD website and business consulting services."
        ogUrl="https://smartresourcesqld.com.au/terms-conditions"
      />
      
      <section className="innr_banner about_innr_banner">
        <div className="page_title_innr">
          <div className="page_title">Terms and Conditions</div>
          <ul className="bread_crumb">
            <li><NavLink to="/">Home</NavLink></li>
            <li>Terms & Conditions</li>
          </ul>
        </div>
      </section>

      <section className="terms_conditions_section" style={{ padding: '80px 0', backgroundColor: '#ffffff', color: '#333333' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="terms_content" style={{ fontFamily: '"Poppins", sans-serif', lineHeight: '1.8', fontSize: '15px' }}>
                <p style={{ marginBottom: '25px', fontSize: '16px', color: '#555555' }}>
                  These Terms and Conditions ("Terms") govern your access to and use of the website 
                  smartresourcesqld.com.au (the "Website") and the business consulting services offered by Smart 
                  Resources QLD ("we", "us", "our"). By accessing or using the Website, or by engaging our services, 
                  you agree to be bound by these Terms. If you do not agree to these Terms, please do not use the 
                  Website or our services.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  1. About Us
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  Smart Resources QLD provides business consulting services to businesses and individuals in 
                  Queensland, Australia. Enquiries can be made through the contact form on our Website.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  2. Use of the Website
                </h3>
                <p style={{ marginBottom: '15px' }}>
                  You agree to use the Website only for lawful purposes and in a manner that does not infringe the 
                  rights of, or restrict or inhibit the use and enjoyment of the Website by, any third party. Prohibited 
                  uses include, but are not limited to:
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '25px', listStyleType: 'disc' }}>
                  <li style={{ marginBottom: '10px' }}>Attempting to gain unauthorised access to the Website, our systems or networks;</li>
                  <li style={{ marginBottom: '10px' }}>Uploading or transmitting viruses, malware or any other harmful code;</li>
                  <li style={{ marginBottom: '10px' }}>Using automated systems (such as bots or scrapers) to access or extract content from the Website without our prior written consent; and</li>
                  <li style={{ marginBottom: '10px' }}>Using the Website to transmit unsolicited or unauthorised advertising or promotional material.</li>
                </ul>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  3. Intellectual Property
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  All content on the Website, including text, graphics, logos, images and software, is the property of 
                  Smart Resources QLD or its licensors and is protected by Australian and international copyright, 
                  trademark and other intellectual property laws. You may view and print content from the Website 
                  for your own personal, non-commercial use, but you must not reproduce, distribute, modify or 
                  create derivative works from any content without our prior written consent.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  4. Enquiries and Consulting Services
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  Submitting an enquiry through our contact form does not, by itself, create a contractual relationship 
                  or obligation on either party. Any consulting services we agree to provide will be subject to a 
                  separate written agreement, proposal, or engagement letter setting out the specific scope, fees and 
                  terms applicable to that engagement, which will prevail over these Terms to the extent of any 
                  inconsistency.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  5. No Professional Advice via the Website
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  General information provided on the Website is for general informational purposes only and does 
                  not constitute professional, legal, financial or business advice. You should not rely on any 
                  information on the Website as a substitute for tailored advice from a qualified professional relevant 
                  to your specific circumstances. Any formal advice will only be provided as part of a specific client 
                  engagement.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  6. Limitation of Liability
                </h3>
                <p style={{ marginBottom: '15px' }}>
                  To the maximum extent permitted by law, Smart Resources QLD makes no warranties or 
                  representations about the accuracy, completeness or reliability of any content on the Website, and 
                  excludes all liability for any loss or damage (including indirect or consequential loss) arising from 
                  your use of, or reliance on, the Website or its content.
                </p>
                <p style={{ marginBottom: '25px' }}>
                  Nothing in these Terms excludes, restricts or modifies any consumer guarantee, right or remedy 
                  conferred on you under the Australian Consumer Law or any other applicable law that cannot 
                  lawfully be excluded, restricted or modified. Where permitted, our liability for breach of any such 
                  guarantee is limited, at our option, to the re-supply of services or the cost of having the services re-
                  supplied.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  7. Third-Party Links
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  The Website may contain links to third-party websites. These links are provided for convenience 
                  only. We do not endorse and are not responsible for the content, accuracy or practices of any third-
                  party website, and access to any linked website is at your own risk.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  8. Privacy
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  Our collection and handling of personal information is governed by our Privacy Policy, which forms 
                  part of these Terms. Please refer to the Privacy Policy above for further details.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  9. Changes to These Terms
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  We may update these Terms from time to time at our discretion. Any changes will be posted on this 
                  page with an updated "last updated" date. Your continued use of the Website following any changes 
                  constitutes your acceptance of the revised Terms.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  10. Termination
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  We reserve the right, without notice, to suspend or terminate your access to the Website if we 
                  reasonably believe you have breached these Terms.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  11. Governing Law
                </h3>
                <p style={{ marginBottom: '25px' }}>
                  These Terms are governed by the laws of Queensland, Australia. You irrevocably submit to the 
                  exclusive jurisdiction of the courts of Queensland and any courts entitled to hear appeals from those 
                  courts in respect of any dispute arising out of or in connection with these Terms.
                </p>

                <h3 style={{ color: '#0e0e0e', fontWeight: '600', marginTop: '35px', marginBottom: '15px', fontSize: '20px', borderBottom: '1px solid #eeeeee', paddingBottom: '8px' }}>
                  12. Contact Us
                </h3>
                <p style={{ marginBottom: '15px' }}>
                  If you have any questions about these Terms and Conditions, please contact us at:
                </p>
                <ul style={{ paddingLeft: '20px', marginBottom: '25px', listStyleType: 'disc' }}>
                  <li style={{ marginBottom: '8px' }}><strong>Business name:</strong> Smart Resources QLD</li>
                  <li style={{ marginBottom: '8px' }}><strong>Website:</strong> <a href="https://smartresourcesqld.com.au" target="_blank" rel="noopener noreferrer" style={{ color: '#800020', fontWeight: '500' }}>smartresourcesqld.com.au</a></li>
                  <li style={{ marginBottom: '8px' }}><strong>Email:</strong> <a href="mailto:reachus@smartresourcesqld.com.au" style={{ color: '#800020', fontWeight: '500' }}>reachus@smartresourcesqld.com.au</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsConditions;
